<template>
  <div class="position-relative">
      <div class="table-container">
        <b-table class="applicant_table animated fadeIn"  v-if="show" responsive hover  :fields="computedFields" :items="applicantList" primary-key="id" :busy="loading">
          <template v-slot:cell(HEAD_selectableCheckbox)="data">

            <div v-if="applicantList.length > 0" class="tableSelectableCheckbox">
              <b-checkbox v-model="selectAllValue" @change="selectAll" size="sm" :inline="true"></b-checkbox>
            </div>
          </template>
          <template v-slot:cell(decision_type) = "data">
              {{data.item.decision_type === 1 ?  $t('PERMANENT') : data.item.decision_type === 2 ?  $t('TEMPORARY') : ''}}
          </template>
          <template v-slot:cell(selectableCheckBox)="data">
            <b-checkbox @change="setSelectedItem($event, data.item)" v-model="selectedIds"
                        :value="data.item['id']"
                        size="sm" :inline="true"></b-checkbox>
          </template>
          <template v-slot:cell(edit)="data">
            <app-button class="pull-right"
                             :c_permission="C_APPLICANT_RECOGNITION_EDIT_BUTTON"
                             :to="{name: routeNames.RN_APPLICANT_BASIC, params:{id: data.item.id}}"
                             size="sm"
                             variant="link">
                   <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </app-button>
          </template>
          <template v-slot:cell(download)="data">
            <app-download
              @click="downloadPdfDocument(data.item.active_decision_setup_id, {first_name: data.item.first_name, last_name: data.item.last_name})"
              :disabled="data.item.status.id === STATUS_IN_PROCESS"
              class="pull-right"
              size="sm"
              variant="link">


            </app-download>
          </template>
          <template v-slot:cell(view)="data">
            <app-button class="pull-right"
                        :c_permission="C_APPLICANT_RECOGNITION_VIEW_BUTTON"
                        :to="{name: routeNames.RN_APPLICANT_BASIC_VIEW, params:{id: data.item.id}}"
                        size="sm"
                        variant="link">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </app-button>
          </template>

        </b-table>
        <b-pagination
          v-show="applicantList.length && lastPage > 1"
          class="app_pagination"
          size="sm"
          :hide-goto-end-buttons="true"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @change="updatePagination">
          <template v-slot:prev-text>
            <i class="fa fa-angle-left" aria-hidden="true"></i>
          </template>

          <template v-slot:next-text>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </template>
        </b-pagination>

        <div class="selectedContainer animated fadeIn" v-if="selectedIds.length">
          <div>
            <h4 v-if="selectedIds.length > 1">{{$t("APPLICANTS_SELECTED", {value: selectedIds.length})}}</h4>
            <h4 v-else-if="selectedIds.length === 1">{{$t("APPLICANT_SELECTED")}}</h4>
            <app-button @click="deselectAll" class="action_button" variant="link">{{$t("DESELECT")}}
            </app-button>
          </div>

          <div class="flex-grow-1 d-flex justify-content-end">
            <slot
              v-bind="{selected:selectedObjects, totalRows:totalRows}"
              name="selectedContainer">
              <app-button
                @click="exportModal=true">
                {{$t("EXPORT")}}
              </app-button>

              <b-modal scrollable :title="$t('EXPORT')" size="lg" v-model="exportModal">
              <b-checkbox :checked="true" @change="updateSelectAllExport">
                {{$t("SELECT_ALL")}}
              </b-checkbox>
              <hr class="p-0 m-0 mb-1 mt-1">
              <b-checkbox-group class="two_col_checkbox_group" v-model="exportActionSelected" stacked
                                :options="exportColumns"></b-checkbox-group>
              <template v-slot:modal-footer>
                <div class="w-100 d-flex justify-content-between align-items-center">
                  <div v-if="totalRows > 1">
                    <b-checkbox v-model="selectAllForExport">
                      {{$t("APPLY_TO_ALL_APPLICANT", {number:totalRows})}}
                    </b-checkbox>
                 <!--   <b-checkbox v-model="selectAllFields">
                      {{$t("APPLY_TO_ALL_FIELDS")}}
                    </b-checkbox>-->
                    <small v-if="totalRows > maxExportLimit" class="text-muted">
                      {{$t('EXPORT_MAX_LIMIT_WARNING', {num:5000})}}
                    </small>
                  </div>
                  <div>
                    <b-checkbox :disabled="selectAllFields || exportActionSelected.length > 10" v-model="downloadPdf">
                      Pdf
                    </b-checkbox>
                    <b-checkbox v-model="downloadXls">
                      Xls
                    </b-checkbox>
                  </div>

                  <app-button :disabled="disabledExport" :loading="downloading" @click="download">
                    {{$t('EXPORT')}}
                  </app-button>
                </div>
              </template>
            </b-modal>
              <b-modal :title="$t('SEND')" v-model="sendModal">
                <b-form-group :label="$t('EMAIL')">
                  <b-input v-model="email"></b-input>
                </b-form-group>
                <b-checkbox :checked="true" @change="updateSelectAllExport">
                  {{$t("SELECT_ALL")}}
                </b-checkbox>
                <hr class="p-0 m-0 mb-1 mt-1">
                <b-checkbox-group class="two_col_checkbox_group" v-model="exportActionSelected" stacked
                                  :options="exportColumns"></b-checkbox-group>
                <template v-slot:modal-footer>
                  <div class="w-100 d-flex justify-content-between align-items-center">

                    <div v-if="totalRows > 1">
                      <b-checkbox v-model="selectAllForExport">
                        {{$t("APPLY_TO_ALL_NUMBER", {number:totalRows})}}
                      </b-checkbox>
                      <small v-if="totalRows > maxExportLimit" class="text-muted">
                        {{$t('EXPORT_MAX_LIMIT_WARNING', {num:5000})}}
                      </small>
                    </div>

         <!--           <app-button :disabled="disabledExport" :loading="downloading" @click="send">
                      {{$t('SEND')}}
                    </app-button>-->
                  </div>
                </template>

              </b-modal>
            </slot>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import {generatePdfDecision, getApplicantList, groupApplicantExport} from "@/services/applicant";
    import AppNoData from "@/components/app/AppNoData";
    import routeNames from "@/router/routeNames";
    import {C_APPLICANT_RECOGNITION_EDIT_BUTTON,C_APPLICANT_RECOGNITION_VIEW_BUTTON} from "@/shared/component_permission";
    import AppButton from "@/components/app/AppButton";
    import AppDownload from "@/components/app/AppDownload";
  import {ECONOMY_BIH, STATUS_IN_PROCESS, USER_DATA} from '@/shared/constants';
  import {downloadPdfRecognitionDecision} from "@/services/recognition";

  export default {
      name: "ApplicantListTable",
      components: {AppDownload, AppButton, AppNoData},
      props:{
        filter:{
          type:Object
        },
        loading:{
          type:Boolean,
          default:false
        }
      },
      data(){
          return {
            routeNames,
            C_APPLICANT_RECOGNITION_EDIT_BUTTON,
            C_APPLICANT_RECOGNITION_VIEW_BUTTON,
            STATUS_IN_PROCESS,
            applicantList:[],
            selectAllValue:null,
            fields:[
              {key:'selectableCheckBox',label:'',tdClass: 'tableSelectableCheckbox'},
              {key:'first_name', label:this.$t('FIRST_NAME')},
              {key:'last_name', label:this.$t('LAST_NAME')},
              {key:'name_of_foreign_qualification', label:this.$t('NAME_QUALIFICATION_IN_THE_ORIGINAL_LANGUAGE')},
              {key:'country.name', label:this.$t('ECONOMY')},
              {key:'decision_recognition', label:this.$t('DECISION')},
              {key:'decision_type', label:this.$t('DECISION_TYPE')},
              {key:'status.name', label:this.$t('STATUS')},
              {key:'download',label:this.$t('DECISION'), tdClass: "p-0 options-column", thClass:"text-center"},
              {key:'edit',label:this.$t('EDIT'),tdClass:"p-0 options-column", thClass:"text-center"},
            ],
            exportColumns: [

              {order: 1, value: 'first_name', text: this.$t('FIRST_NAME')},
              {order: 2, value: 'last_name', text: this.$t('LAST_NAME')},
              {order: 3, value: 'date_of_birth', text: this.$t('DATE_OF_BIRTH')},
              {order: 4, value: 'gender', text: this.$t('GENDER')},
              {order: 5, value: 'country.name', text: this.$t('ECONOMY')},
              {order: 6, value: 'city', text: this.$t('TOWN')},
              {order: 7, value: 'nationality', text: this.$t('NATIONALITY')},
              {order: 8, value: 'contact', text: this.$t('CONTACT')},
              {order: 9, value: 'request_protocol_number', text: this.$t('REQUEST_PROTOCOL_NUMBER')},
              {order: 10, value: 'date_receipt_request', text: this.$t('DATE_OF_APPLICATION')},
              {order: 11, value: 'name_awarding_institution_original_lang', text: this.$t('ORIGIN_INSTITUTION')},
              {order: 12, value: 'name_of_foreign_qualification', text: this.$t('ORIGINAL_TITLE_OF_HIGHER_QUALIFICATION')},
              {order: 13, value: 'country_of_origin.name', text: this.$t('ECONOMY')},
              {order: 14, value: 'city_of_institution', text: this.$t('CITY_OF_INSTITUTION')},
              {order: 15, value: 'accreditation_status', text: this.$t('ACCREDITATION_STATUS')},
              {order: 16, value: 'accredited_study_program', text: this.$t('ACCREDITED_STUDY_PROGRAM')},
              {order: 17, value: 'level_qualification_country_origin', text: this.$t('LEVEL_OF_QUALIFICATION_ORIGIN_COUNTRY')},
              {order: 18, value: 'qualification_awarding_date', text: this.$t('QUALIFICATION_AWARDING_DATE')},
              {order: 19, value: 'document_number', text: this.$t('DEGREE_NUMBER_THE_COUNTRY_OF_ORIGIN')},
              {order: 20, value: 'original_name_accompanying_public_document', text: this.$t('ORIGINAL_NAME_THE_SUPPORTING_DOCUMENTATION')},
              {order: 21, value: 'qualification_area.name', text: this.$t('SCIENTIFIC_AREA')},
              {order: 22, value: 'study_level', text: this.$t('STUDIES_LEVEL')},
              {order: 23, value: 'eqf_level', text: this.$t('EQF_LEVEL')},
              {order: 24, value: 'nqf', text: this.$t('LEVEL_OF_QUALIFICATION_IN_COUNTRY_RECOGNITION')},
              {order: 25, value: 'enrollment_requirements', text: this.$t('CONDITIONS_FOR_ENTRY')},
              {order: 26, value: 'ects_enrollment', text: this.$t('ECTS_ENROLLMENT')},
              {order: 27, value: 'name_of_study_program_country_origin', text: this.$t('NAME_OF_FOREIGN_STUDY_PROGRAM')},
              {order: 28, value: 'load_of_study_program', text: this.$t('CREDIT_POINTS_COUNTRY_ORIGIN')},
              {order: 29, value: 'ects', text: this.$t('ECTS')},
              {order: 30, value: 'further_study', text: this.$t('FURTHER_STUDY')},
              {order: 31, value: 'recognition_date', text: this.$t('RECOGNITION_DATE')},
              {order: 32, value: 'decision_protocol_number', text: this.$t('DECISION_PROTOCOL_NUMBER')},
              {order: 33, value: 'recognized', text: this.$t('RECOGNIZED_AS')},
              {order: 34, value: 'decision_recognition', text: this.$t('COMPETENT_RECOGNITION_AUTHORITY')},
              {order: 35, value: 'non_recognition_reason', text: this.$t('NON_RECOGNITION_REASON')},
              {order: 36, value: 'description_decision', text: this.$t('DESCRIPTION_DECISION')},
              {order: 37, value: 'status.name', text: this.$t('STATUS')},
            ],
            show:true,
            lastPage:0,
            currentPage:1,
            perPage:10,
            totalRows:0,
            limit:10,
            primaryKey:'id',

            selectedIds:[],
            selectedObjects:[],

            downloading: false,
            exportActionSelected: [],
            selectAllForExport: false,
            selectAllFields:false,
            exportModal: false,
            downloadPdf:false,
            downloadXls:false,
            maxExportLimit:5000,
            sendModal:false,
            email:null,
          }
        },
      methods:{
        downloadPdfDocument(id, {first_name, last_name}) {
          downloadPdfRecognitionDecision(id).then((response) => {
            let blob = new Blob([response], {type: 'application/pdf'});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`${first_name}${last_name}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
        },
        fetchPdfDecision(id){

          generatePdfDecision(id)
        },
        send(){

        },
      async  download(data){
        if (this.downloadXls) {
          this.downloadExportFile('xls')
        }
        if (this.downloadPdf) {
          this.downloadExportFile('pdf')
        }

        },
        downloadExportFile(filetype) {
          this.downloading = true
          if (this.filter.hasOwnProperty('perPage')) {
            this.filter.perPage = this.maxExportLimit
          } else {
            this.filter.limit = this.maxExportLimit
          }

          groupApplicantExport({
            fields: this.selectedExportColumn,
            data: this.selectedObjects,
            filter: this.selectAllForExport || this.selectAllFields  ? this.filter : null,
            all_fields: this.selectAllFields
          }, filetype).finally(() => {
            this.downloading = false
            this.selectedIds = []
            this.selectedObjects = []
            this.selectAllValue = false
            this.exportModal = false
          })
        },

        setSelectedItem($event, el) {

          let index = this.selectedIds.indexOf(el[this.primaryKey])

          if (index >= 0) {
            this.selectedIds.splice(index, 1)
            this.selectedObjects.splice(index, 1)
          }
          if ($event) {
            this.selectedIds.push(el[this.primaryKey])
            this.selectedObjects.push(el)
          } else {
            this.selectAllValue = false
          }
        },
          getTableData(request){
            this.$emit('busyToggled', true)
            getApplicantList(request).then(response => {
              this.applicantList = response.data.items
              this.currentPage = response.data.page
                this.totalRows = response.data.total
                this.lastPage = response.data.last_page
            }, () => {
              this.applicantList = []
            }).finally(()=> {
              this.$emit('busyToggled', false)
            })
          },
        selectAll($event) {

        },
        updatePagination(value) {
          this.selectAllValue = false
          this.currentPage = value
          let request= {
            ...this.filter,
            ...{page:this.currentPage,limit:this.limit}
          }
          this.getTableData(request)
        },
        deselectAll() {
          this.selectedIds = []
          this.selectedObjects = []
          this.selectAllValue = false
        },
        updateSelectAllExport($event) {
          if ($event) {
            this.exportActionSelected = this.exportColumns.map(el => el.value)
          } else {
            this.exportActionSelected = []
          }
        },
      },
      computed:{

        computedFields(){
          const fields = this.fields
          if(!this.visibleTemporaryDecision){
            const index = fields.findIndex(el=>el.key==='decision_type')
            fields.splice(index,1)
            return  fields
          } else  {
            return  fields
          }
        },
        user(){
          return JSON.parse(localStorage.getItem(USER_DATA))
        },
        visibleTemporaryDecision(){
          return Number(this.user.economy.id) === ECONOMY_BIH
        },

        disabledExport() {

          return this.exportActionSelected.length === 0 || (!this.downloadPdf && !this.downloadXls)
        },
        selectedExportColumn() {
          let data = []
          if (this.exportActionSelected.length) {
            this.exportColumns.map(el => {
              this.exportActionSelected.forEach(item => {
                if (item === el.value) {
                  data.push({
                    key: el.value,
                    label: el.text
                  })
                }
              })
            })
          }
          return data
        },

      },

       watch: {
         exportActionSelected:{
           handler(value){
             if(value.length > 10){
               this.downloadPdf = false
             }
           }
         },
         selectAllFields: {
           handler(value){
             console.log(value,333)
             if(value){
               this.downloadPdf = false
             }
           }
         },
        filter: {
       async   handler(filterObject) {
         let request = {
           ...filterObject,
           ...{

             limit:this.limit,
             page:this.currentPage
           }
         }
            await  this.getTableData(request)
          },
          deep: true,
          immediate:true
        },
         exportModal: {
           handler(value) {
             if (value) {
               this.exportActionSelected = this.exportColumns.map(el => el.value)
             }

           }
         }
      }
    }
</script>

<style >
.options-column{
  width: 2rem;
}
</style>
